<template>
  <div class="mx-auto card_container">
    <v-container class="card_container">
      <v-row justify="space-between" align="center" class="mx-1">
        <toolbar-titles :title="$tc('nav.gestionEmpleados')" />
        <v-btn-toggle
          group
          tile
          color="indigo lighten-2 accent-3"
          v-model="buttonSelected"
        >
          <v-btn @click="cardView">Carta</v-btn>
          <v-btn @click="listView">Lista</v-btn>
        </v-btn-toggle>
      </v-row>

      <v-row>
        <v-col cols="12" class="container_table">
          <div v-show="showCard">
            <Card @refreshItems="refreshItems" />
          </div>
          <div v-show="showTable">
            <Table @refreshItems="refreshItems" />
          </div>
        </v-col>
      </v-row>

      <!-- Nueva fila solo para el paginado -->
      <v-row justify="center">
        <v-pagination
          v-if="getEmployees?.length > 0"
          class="paginado"
          v-model="currentPage"
          :length="totalPages"
          prev-icon="mdi-chevron-left"
          next-icon="mdi-chevron-right"
          hide-delimiter-background
          :items-per-page="limit"
          @input="changePage"
        />
      </v-row>
      <Snackbar :alert="alert" :color="color" :textAlert="textAlert" />
    </v-container>
  </div>
</template>

<script>
import ToolbarTitles from "../Complement/ToolbarTitles.vue";
import Card from "./Views/Card.vue";
import Employee from "./Views/Employee/Employee.vue";
import Table from "./Views/Table.vue";
import Navigation from "./Views/Employee/Navigation.vue";
import AddEmployee from "./Views/Employee/AddEmployee.vue";
import Snackbar from "../../components/Complement/Snackbar.vue";
import { getConfig } from "@/config";

export default {
  components: {
    ToolbarTitles,
    Card,
    Employee,
    Table,
    Navigation,
    AddEmployee,
    Snackbar,
  },
  data() {
    return {
      buttonSelected: 0,
      buttons: [
        { id: 1, text: "Tarjeta" },
        { id: 2, text: "Lista" },
      ],
      text: undefined,
      loading: true,
      textAlert: "",
      alert: false,
      color: "",
      _config: null,
    };
  },
  async mounted() {
    this.$store.dispatch("tags/getTags");
    this.$store.state.employees.employees = [];
    await this.$store.dispatch("employees/getEmployeesPaginate").then(() => {
      if (!this.showTable) {
        this.$store.commit("employees/setShowCard", true);
        this.buttonSelected = 0;
      } else {
        this.$store.commit("employees/setShowTable", true);
        this.buttonSelected = 1;
      }
      this.loading = false;
    });
    if (this.config.enroll === "suprema") {
      await this.$store.dispatch("employees/getDevices").catch(() => {
        this.alertDispatch(
          this.$tc("gestionEmpleados.notConnectionBiostar"),
          "error",
          true
        );
      });
      await this.$store.dispatch("employees/getUsersSuprema");
    }
  },
  computed: {
    config() {
      if (!this._config) {
        const cfg = getConfig();
        if (!cfg) throw new Error("Config not loaded");
        this._config = cfg;
      }
      return this._config;
    },

    getTags() {
      return this.$store.state.tags.tags.filter(
        (tag) => tag.scope === "empleados"
      );
    },
    showCard: {
      get() {
        return this.$store.state.employees.showCard;
      },
      set(newValue) {
        return newValue;
      },
    },
    showTable: {
      get() {
        return this.$store.state.employees.showTable;
      },
      set(newValue) {
        return newValue;
      },
    },
    getEmployees() {
      return this.$store.state.employees.employees;
    },
    currentPage: {
      get() {
        return this.$store.state.employees.currentPage;
      },
      set(value) {
        this.$store.state.employees.currentPage = value;
      },
    },
    totalPages() {
      return this.$store.getters["employees/totalPages"];
    },
    limit() {
      return this.$store.state.employees.limit;
    },
  },

  methods: {
    alertDispatch(text, color, alert) {
      this.alert = alert;
      this.textAlert = text;
      this.color = color;
      setTimeout(() => {
        this.alert = false;
      }, 3000);
    },
    async refreshItems() {
      this.$store.commit("employees/setLimit", 44);
      await this.$store.dispatch("employees/getEmployeesPaginate");
    },
    async changePage(page) {
      this.loading = true;
      await this.$store.dispatch("employees/updatePage", page);
      this.loading = false;
    },
    cardView() {
      this.$store.commit("employees/setShowCard", true);
      this.$store.commit("employees/setShowTable", false);
    },
    listView() {
      this.$store.commit("employees/setShowTable", true);
      this.$store.commit("employees/setShowCard", false);
    },
  },
};
</script>

<style scoped>
.card_container {
  max-width: 100%;
}
.paginado {
  padding-top: 10px;
  padding-bottom: 10px;
}

@media (max-width: 1919px) {
  .card_container {
    padding-top: 0;
    padding-bottom: 0; /* Eliminar padding en resoluciones menores a Full HD */
    margin-top: 0;
    margin-bottom: 0;
  }
  .paginado {
    margin-top: -15px;
    margin-bottom: 0;
  }
  .container_table {
    margin-top: -15px;
  }
}
</style>
